/**
 * Canonical dimension system — frontend constants.
 * Display IDs (1D, 2D, etc.) are used in API and DB.
 * These constants are the single-source-of-truth for frontend logic.
 */

export const DIM = {
  NOTES:    '1D',
  IMAGE:    '2D',
  VIDEO:    '2.5D',
  MODEL3D:  '3D',
  GEOSPACE: '3.5D',
  XR:       '4D',
};

export const DIM_LABELS = {
  '1D':   'Notes',
  '2D':   'Image',
  '2.5D': 'Video',
  '3D':   'Model',
  '3.5D': 'Place',
  '4D':   'XR',
};

// User-facing mode labels shown in the top bar chip and UI
export const DIM_MODE_LABELS = DIM_LABELS;

export const DIM_COLORS = {
  '1D':   '#a78bfa',
  '2D':   '#ec4899',
  '2.5D': '#fb923c',
  '3D':   '#00c8ff',
  '3.5D': '#34d399',
  '4D':   '#fbbf24',
};

// Asset categories each dimension can load
export const DIM_ACCEPTED_CATEGORIES = {
  '1D':   ['document'],
  '2D':   ['image'],
  '2.5D': ['video'],
  '3D':   ['model3d'],
  '3.5D': ['model3d', 'unknown'],
  '4D':   ['model3d', 'image', 'video', 'document'],
};

// Dimensions that require a non-null activeAsset to show content
// Notes (1D) is excluded — it uses a local card board
export const ASSET_REQUIRED_DIMS = new Set(['2D', '2.5D', '3D', '3.5D', '4D']);

export function requiresAsset(dimensionId) {
  return ASSET_REQUIRED_DIMS.has(dimensionId);
}

// Full dimension metadata for UI components (AssistantPanel, headers, chips)
export const DIMENSION_META = {
  '1D':   { label: 'Notes',  color: 'rgba(168,85,247,0.9)',  bg: 'rgba(168,85,247,0.09)'  },
  '2D':   { label: 'Image',  color: 'rgba(236,72,153,0.9)',  bg: 'rgba(236,72,153,0.09)'  },
  '2.5D': { label: 'Video',  color: 'rgba(251,146,60,0.9)',  bg: 'rgba(251,146,60,0.09)'  },
  '3D':   { label: 'Model',  color: 'rgba(0,200,255,0.9)',   bg: 'rgba(0,200,255,0.09)'   },
  '3.5D': { label: 'Place',  color: 'rgba(52,211,153,0.9)',  bg: 'rgba(52,211,153,0.09)'  },
  '4D':   { label: 'XR',     color: 'rgba(251,191,36,0.9)',  bg: 'rgba(251,191,36,0.09)'  },
};

// kind (DB field) → hex color for sidebar / asset chips
export const KIND_COLOR = {
  thought:  '#a78bfa',
  canvas2d: '#ec4899',
  video:    '#fb923c',
  model3d:  '#00c8ff',
  geospace: '#34d399',
  canvas3d: '#fbbf24',
};

// kind → short dimension label
export const KIND_DIM_SHORT = {
  thought:  '1D',
  canvas2d: '2D',
  video:    '2.5D',
  model3d:  '3D',
  geospace: '3.5D',
  canvas3d: '4D',
};

// kind → space display name
export const SPACE_LABELS = {
  thought:  'Thought Space',
  canvas2d: 'Graphical Space',
  video:    'Motion Space',
  model3d:  'Model Space',
  geospace: 'GeoSpace',
  canvas3d: 'Immersive Space',
};
